module.exports = __webpack_public_path__ + "img/unionpay-small.a399cd4d.svg";